module.exports = __webpack_public_path__ + "img/6.5d393b6b.jpg";